"use client";

import React from 'react';
import { cn } from '@/lib/utils';

export interface DropdownMenuSearchProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  className?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  variant?: 'default' | 'subtle'; // 'default' has border/shadow, 'subtle' has background only
}

export function DropdownMenuSearch({
  placeholder = "Search...",
  value = "",
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  className,
  autoFocus = false,
  disabled = false,
  variant = 'default',
}: DropdownMenuSearchProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  const variantStyles = {
    default: "bg-[color-mix(in_srgb,var(--hover-bg),transparent_45%)] border border-component focus-within:ring-2 focus-within:ring-blue-500",
    subtle: "bg-[color-mix(in_srgb,var(--hover-bg),transparent_45%)]",
  };

  return (
    <div
      className={cn(
        "flex items-center w-full h-[30px] px-[9px] gap-2 rounded-[7px]",
        variantStyles[variant],
        className
      )}
    >
              <input
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                autoFocus={autoFocus}
                disabled={disabled}
                className={cn(
                  "w-full text-sm border-none bg-transparent",
                  "focus:outline-none",
                  "text-gray-900 dark:text-white",
                  "placeholder-faint",
                  disabled && "opacity-50 cursor-not-allowed"
                )}
              />
    </div>
  );
}

